// Adapted from the @shadcndesign app-shell-4 NavUser block.
import React, { useId } from "react";
import { ChevronsUpDown } from "lucide-react";

import AccountMenu from "@/Components/AccountMenu/AccountMenu";
import { useTranslation } from "@/context/Internationalization";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/shadcn/components/ui/avatar";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/shadcn/components/ui/sidebar";

const SidebarUserMenu = ({ user, showSettings, onOpenSettings, onLogout }) => {
  const { t } = useTranslation();
  const { isMobile } = useSidebar();
  const labelId = useId();
  const identityId = useId();
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
  const contact = user?.email?.trim() || user?.mobile || "";
  const initials = `${(user?.firstName || "").charAt(0)}${(
    user?.lastName || ""
  ).charAt(0)}`;

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <AccountMenu
          trigger={
            <SidebarMenuButton
              size="lg"
              className="data-popup-open:bg-sidebar-accent data-popup-open:text-sidebar-accent-foreground"
            />
          }
          // The spoken name includes the visible user name (WCAG 2.5.3).
          triggerProps={{ "aria-labelledby": `${labelId} ${identityId}` }}
          onOpenSettings={onOpenSettings}
          onLogout={onLogout}
          showSettings={showSettings}
          side={isMobile ? "bottom" : "right"}
          align="end"
          contentClassName="w-(--anchor-width) min-w-56"
        >
          <Avatar
            aria-hidden="true"
            className="size-8 rounded-lg after:rounded-lg"
          >
            <AvatarImage
              src={user?.photo || undefined}
              alt=""
              className="rounded-lg"
            />
            {/* Decorative initials drawn by CSS, so they are not part of the button's name. */}
            <AvatarFallback
              className="rounded-lg before:content-[attr(data-initials)]"
              data-initials={initials}
            />
          </Avatar>
          <span id={labelId} className="sr-only">
            {t("open_account_menu")}
          </span>
          <div
            id={identityId}
            className="grid flex-1 text-left text-sm leading-tight"
          >
            <span className="truncate font-semibold">{name}</span>
            <span className="truncate text-xs" title={contact}>
              {contact}
            </span>
          </div>
          <ChevronsUpDown className="ml-auto" aria-hidden="true" />
        </AccountMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};

export default SidebarUserMenu;
